import React from 'react';
import { Link } from 'react-router-dom';
import { FiFileText, FiBriefcase, FiArrowRight } from 'react-icons/fi';

const Dashboard = () => {
    const stats = [
        { title: 'Total Blogs', count: '6', icon: FiFileText, color: 'bg-blue-500', link: '/admin/blogs' },
        { title: 'Active Jobs', count: '3', icon: FiBriefcase, color: 'bg-green-500', link: '/admin/careers' },
    ];

    return (
        <div>
            <div className="mb-8">
                <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>
                <p className="text-gray-500">Overview of your website content</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                {stats.map((stat) => (
                    <div key={stat.title} className="bg-white rounded-xl shadow-sm p-6 flex items-center justify-between">
                        <div>
                            <p className="text-gray-500 text-sm font-medium mb-1">{stat.title}</p>
                            <h3 className="text-3xl font-bold text-gray-800">{stat.count}</h3>
                        </div>
                        <div className={`w-12 h-12 rounded-lg flex items-center justify-center text-white ${stat.color}`}>
                            <stat.icon size={24} />
                        </div>
                    </div>
                ))}
            </div>

            <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl shadow-sm p-6">
                    <div className="flex items-center justify-between mb-6">
                        <h3 className="font-bold text-gray-800">Quick Actions</h3>
                    </div>
                    <div className="space-y-4">
                        <Link to="/admin/blogs" className="block p-4 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors group">
                            <div className="flex items-center justify-between">
                                <span className="font-medium text-gray-700">Manage Blog Posts</span>
                                <FiArrowRight className="text-gray-400 group-hover:text-primary-500 transition-colors" />
                            </div>
                        </Link>
                        <Link to="/admin/careers" className="block p-4 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors group">
                            <div className="flex items-center justify-between">
                                <span className="font-medium text-gray-700">Manage Job Listings</span>
                                <FiArrowRight className="text-gray-400 group-hover:text-primary-500 transition-colors" />
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
